export default __webpack_public_path__ + "static/media/great.b6916730.svg";